
(() => {
  const init = (root) => {
    if (!root || root.dataset.jtgsReady === 'true') return;
    root.dataset.jtgsReady = 'true';
    document.documentElement.classList.add('jtgs-smooth');

    const modal = root.querySelector('[data-jtgs-modal]');
    const modalTitle = modal?.querySelector('[data-jtgs-modal-title]');
    const modalMedia = modal?.querySelector('[data-jtgs-modal-media]');
    const closeButton = modal?.querySelector('[data-jtgs-modal-close]');
    const backdrop = modal?.querySelector('[data-jtgs-modal-backdrop]');
    let lastTrigger = null;

    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (modalMedia) modalMedia.innerHTML = '';
      lastTrigger?.focus?.();
      lastTrigger = null;
    };

    const openImage = (trigger) => {
      if (!modal || !modalMedia || !trigger.dataset.imageSrc) return;
      lastTrigger = trigger;
      modalTitle.textContent = trigger.dataset.modalTitle || 'View image';
      modalMedia.innerHTML = '';
      const img = document.createElement('img');
      img.src = trigger.dataset.imageSrc;
      img.alt = trigger.dataset.imageAlt || '';
      modalMedia.appendChild(img);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      closeButton?.focus();
    };

    const openView = (trigger) => {
      if (!modal || !modalMedia) return;
      const embed = trigger.dataset.embedUrl;
      const image = trigger.dataset.imageSrc;
      lastTrigger = trigger;
      modalTitle.textContent = trigger.dataset.modalTitle || 'Grandstand viewpoint';
      modalMedia.innerHTML = '';

      if (embed) {
        const frame = document.createElement('iframe');
        frame.src = embed;
        frame.title = trigger.dataset.modalTitle || '360 degree viewpoint';
        frame.loading = 'lazy';
        frame.allow = 'fullscreen; gyroscope; accelerometer';
        frame.setAttribute('allowfullscreen', '');
        modalMedia.appendChild(frame);
      } else if (image) {
        const img = document.createElement('img');
        img.src = image;
        img.alt = trigger.dataset.imageAlt || '';
        modalMedia.appendChild(img);
      } else return;

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      closeButton?.focus();
    };

    root.addEventListener('click', (event) => {
      const imageTrigger = event.target.closest('[data-jtgs-image-open]');
      const viewTrigger = event.target.closest('[data-jtgs-view-open]');
      if (imageTrigger) return openImage(imageTrigger);
      if (viewTrigger) return openView(viewTrigger);
    });

    closeButton?.addEventListener('click', closeModal);
    backdrop?.addEventListener('click', closeModal);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        const target = root.querySelector(href) || document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  };

  const initAll = () => document.querySelectorAll('[data-jtgs-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once:true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
